import { render, staticRenderFns } from "./uploadFileClaim.vue?vue&type=template&id=c9a460dc&scoped=true"
import script from "./uploadFileClaim.vue?vue&type=script&lang=js"
export * from "./uploadFileClaim.vue?vue&type=script&lang=js"
import style0 from "./uploadFileClaim.vue?vue&type=style&index=0&id=c9a460dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a460dc",
  null
  
)

export default component.exports